import { scrollTo, enableScroll, disableScroll } from '../Utils';

const scrollEls = document.querySelectorAll('[data-scroll]');

export function scrollToElement(elID, time, offset = 0) {
  disableScroll();
  const targetPos = document.getElementById(elID).getBoundingClientRect().top + offset;
  scrollTo(targetPos, time || 1000, enableScroll);
}

export default function initScrollers() {
  scrollEls.forEach((el) => {
    el.addEventListener('click', (evt) => {
      const target = evt.currentTarget.getAttribute('data-scroll');
      scrollToElement(target);
    });
  });
}




// WEBPACK FOOTER //
// ./src/javascript/main/MoreBtns/index.js